<template>
  <n-modal
    v-model:show="changePasswordModalVisible"
    :mask-closable="false"
    :closable="false"
    preset="dialog"
    width="800px"
    :showIcon="false"
    :close-on-esc="false"
    class="password-modal"
    contentClass="password-modal__content"
  >
    <header class="my-20px flex items-center justify-between">
      <h3 class="text-[#1e1e1e] text-center flex-1">修改默认密码</h3>
      <n-button text class="text-right" @click="handleJump">跳过></n-button>
    </header>
    <HpForm v-model="formData" :form-items="formItems" />
    <div class="button">
      <CustomButton
        @click="handleSubmit"
        type="primary"
        round
        block
        size="medium"
      >
        确认修改
      </CustomButton>
    </div>
  </n-modal>
</template>

<script lang="ts" setup>
import HpForm from '@/base-ui/hp-form'
import useLoginStore from '@/store/login/login'
import { computed } from 'vue'
import { createFormConfig } from './config/form.config'

const loginStore = useLoginStore()
const changePasswordModalVisible = computed({
  get: () => loginStore.changePasswordModalVisible,
  set: (value) => {
    loginStore.changePasswordModalVisible = value
  }
})
const { formItems, formData, handleSubmit } = createFormConfig({
  loginStore
})

const handleJump = () => {
  loginStore.skipChangePassword()
}
</script>

<style lang="scss">
.password-modal {
  padding: 0 30px 20px !important;
  width: 480px !important;
}
</style>
